import { useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Supabase puts auth callback data in the URL hash (#access_token=..., #error=..., etc.).
 * If the project "Site URL" is the homepage, users land on / with that hash — LoginPage
 * never runs. Send those hashes to /login so we can show reset password or error UI.
 */
export default function AuthHashRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    const hash = window.location.hash;
    if (!hash || hash.length <= 1) return;

    const params = new URLSearchParams(hash.slice(1));
    const looksLikeAuthCallback =
      params.has('error') ||
      params.has('error_code') ||
      params.get('type') === 'recovery' ||
      params.has('access_token');

    if (!looksLikeAuthCallback) return;

    const path = location.pathname;
    if (path === '/' || path === '') {
      navigate({ pathname: '/login', hash: hash.slice(1) }, { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
}
